import { DocumentoVO } from "./documentoVO";
import { DocumentoProtocolloVO } from "./documento-protocolloVO";
import { DocumentoGescorVO } from "./gescor/documento-gescorVO";
import { ClassificaVO } from "./classificaVO";
import { ClassificaGescorVO } from "./gescor/classifica-gescorVO";

export class MetadatiProtocolloVO {
  idBozza: string;

  numeroProtocollo: string;

  dataProtocollo: string;

  tipo: string;

  protocollazioneRiservata: Boolean;

  classifica: ClassificaGescorVO[];

  riferimentoSegnatura: DocumentoGescorVO;

  segnatura: string;
}
